import {
  sanitizeUrl
} from "./chunk-FQGVY4KD.js";

// src/capture.ts
import * as Sentry from "@sentry/nextjs";
var SEVERITY_TO_LEVEL = {
  critical: "fatal",
  high: "error",
  medium: "error",
  low: "warning"
};
function captureWithSentry(error, options = {}) {
  try {
    const errorObject = typeof error === "string" ? new Error(error) : error;
    const { context = {} } = options;
    const tags = { ...options.tags };
    if (options.type) {
      tags.error_type = options.type;
    }
    if (options.severity) {
      tags.severity = options.severity;
    }
    if (context.organizationId) {
      tags.organization_id = context.organizationId;
    }
    if (context.sessionId) {
      tags.session_id = context.sessionId;
    }
    if (context.route) {
      tags.route = context.route;
    }
    if (context.method) {
      tags.method = context.method;
    }
    if (context.statusCode !== void 0) {
      tags.status_code = String(context.statusCode);
    }
    if (context.requestId) {
      tags.request_id = context.requestId;
    }
    const url = context.url ? sanitizeUrl(context.url) : void 0;
    if (url) {
      tags.url = url;
    }
    const extra = withoutNetworkIdentifiers({ ...context.extra, ...options.extra });
    const id = Sentry.captureException(errorObject, {
      level: SEVERITY_TO_LEVEL[options.severity ?? "high"],
      ...options.fingerprint ? { fingerprint: [options.fingerprint] } : {},
      ...context.userId ? { user: { id: context.userId } } : {},
      tags,
      ...Object.keys(extra).length > 0 ? { extra } : {}
    });
    return { id };
  } catch (captureError) {
    console.error("Failed to report error to Sentry:", captureError);
    return null;
  }
}
function withoutNetworkIdentifiers(extra) {
  const { ip: _ip, clientIp: _clientIp, userAgent: _userAgent, ...rest } = extra;
  return rest;
}

export {
  captureWithSentry
};
